<div style="margin: 16px 0;">
    <div class="px-4 flex flex-row flex-wrap justify-between items-center content-center">
        <h3 style="font-size: 16px;">Horarios</h3>
        <button type="button" mat-raised-button mat-button-sm color="primary" class="me-4 mb-4" (click)="openDialog()">
            Agregar horario 
        </button>
    </div>

    <ngx-datatable class="material" [messages]="messages" [rows]="data" [columnMode]="'force'" [headerHeight]="45"
        rowHeight="auto">

        <ngx-datatable-column name="#" [width]="10" [canAutoResize]="false" [sortable]="false" [draggable]="false">
            <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                {{ rowIndex + 1 }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Tipo" prop="tipo_horario.name"></ngx-datatable-column>
        <ngx-datatable-column name="Descripción" prop="descripcion"></ngx-datatable-column>
        <ngx-datatable-column name="Días" prop="periodicidad"></ngx-datatable-column>
        <ngx-datatable-column name="Inicio" prop="horaInicio"></ngx-datatable-column>
        <ngx-datatable-column name="Fin" prop="horaFin"></ngx-datatable-column>
        <ngx-datatable-column name="Acciones" [width]="200" [canAutoResize]="false" [sortable]="false">
            <ng-template let-value="value" ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                <button mat-stroked-button mat-button-sm color="primary" type="button" class="me-2"
                    (click)="editSchedule(row, rowIndex)">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-stroked-button mat-button-sm  type="button" (click)="deleteSchedule(rowIndex)">
                    <mat-icon>delete</mat-icon>
                </button>
            </ng-template>
        </ngx-datatable-column>

    </ngx-datatable>
</div>